import { render, staticRenderFns } from "./preRegistOptionTab.vue?vue&type=template&id=2757394c&"
import script from "./preRegistOptionTab.vue?vue&type=script&lang=js&"
export * from "./preRegistOptionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports